import React, { useEffect } from 'react';
import { Routes as Switch, Route, useNavigate } from 'react-router-dom';

import Layout from 'components/layout';
import Home from 'pages/Home';
import Sets from 'pages/Sets';
import SetsDetails from 'pages/SetsDetails';
import Tutorials from 'pages/Tutorials';
import { Login, ForgotPassword } from 'pages/Auth';
import Admin from 'pages/Admin';
import Storage from 'utils/storage';

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  useEffect(() => {
    Storage.auth.getAuthToken().then((token) => {
      if (!token) {
        return navigate('/login');
      }
    });
  }, [navigate]);

  return children;
};

const Routes = () => {
  return (
    <Layout>
      <Switch>
        <Route path='' exact element={<Home />} />
        <Route path='login' element={<Login />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route
          path='admin/*'
          exact
          element={
            <PrivateRoute>
              <Admin />
            </PrivateRoute>
          }
        />
        <Route
          path='sets'
          element={
            <PrivateRoute>
              <Sets />
            </PrivateRoute>
          }
        />
        <Route
          path='sets/*'
          element={
            <PrivateRoute>
              <SetsDetails />
            </PrivateRoute>
          }
        />
        <Route
          path='tutorials'
          element={
            <PrivateRoute>
              <Tutorials />
            </PrivateRoute>
          }
        />
      </Switch>
    </Layout>
  );
};

export default Routes;
